/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Filter_StubInputs */

const cs_portals_filter_stub = /** @type {(inputs: Portals_Filter_StubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravujeme`)
};

const en_portals_filter_stub = /** @type {(inputs: Portals_Filter_StubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Portals_Filter_StubInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_filter_stub = /** @type {((inputs?: Portals_Filter_StubInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Filter_StubInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_filter_stub(inputs)
	return cs_portals_filter_stub(inputs)
});